export const SpecialUser = {
	PatrickLanz: 2,
	AlbertoRigamonti: 3,
	LegalDepartment: 44,
	AnniePeytavin: 49,
	AliseKessler: 89,
	RahelehAhadpour: 93,
	UlianaMalysheva: 96,
	RomainLanz: 17139,
	CEVBeach: 17314,
	YuCao: 22646,
	LarryCarrel: 30225,
	YordanZhechev: 37735,
	AlessandraDeliberato: 44823,
	AceAsas: 45494,
	MehdiMhidi: 46936,
	AdrianaTatasel: 48235,
	BrendanChiang: 51926,
	ShalinyKrishnan: 52558,
	CharlotteBourquin: 63756,
	LucasValle: 75826,
	MeganeBianco: 75830,
	JulienRipouteau: 87801,
	TestDevFederation: 37,
	TestDevFrFederation: 21345,
	HugoDerycke: 41453,
	ThomaLiechti: 70698,
	HiteshMalhotra: 34282,
	PatrickDeBuren: 62736,
	YannMoser: 72005,
	LauraUrizar: 89497,
	TomBrackebusch: 89499,
	StevenBrescia: 89776,

	// TD
	ChangChiMingThomas: 26417,
	PirvCristina: 52214,
	HumercaGregor: 58522,
	FuengtharnthipPhenyada: 64471,
	CalderonValadezManuelAbraham: 65847,
	RathZobernigGottfried: 89339,
	RuoqiHui: 64410,
	WongSeamus: 67477,
	VISSMR: 59894,
	MelnykMykhailo: 87119,
	KostulskaNatalia: 34468,
	TakaiAya: 50658,
	IvanovicAnka: 34386,
	BrokaneInara: 21544,
	VISBRN: 32056,
	MelanieSanford: 34389,
	AlainFischbacher: 34412,
	SamuelMontalvo: 75847,
	VISIRL: 54374,
	MarekProkes: 61090,
	YannLavallez: 51829,
	JoshuaToltesi: 74965,
	MeriauxMathieu: 34376,
	HubertTomaszewski: 53627,
	NikosSofianos: 24661,
	FulvioDanilas: 36483,
	JohnSwan: 58846,
	BaiDodouJallow: 90627,
	InesVidic: 92255,
} as const;
